import { useState, useEffect } from "react";
import moment from "moment";

export function useQueryFilters(defaults) {
  const [filtros, setFiltros] = useState(defaults);
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    const p = new URLSearchParams(window.location.search);
    const parsed = {
      titulo: p.get("titulo") || defaults.titulo,
      tipo: p.has("tipo") ? +p.get("tipo") : defaults.tipo,
      categoria: p.get("categoria") || defaults.categoria,
      estado: p.has("estado") ? +p.get("estado") : defaults.estado,
      emisor: p.get("emisor") || defaults.emisor,
      receptor: p.get("receptor") || defaults.receptor,
      fechaDesde: p.get("fechaDesde")
        ? moment(p.get("fechaDesde"), "YYYY-MM-DD").startOf("day")
        : defaults.fechaDesde,
      fechaHasta: p.get("fechaHasta")
        ? moment(p.get("fechaHasta"), "YYYY-MM-DD").endOf("day")
        : defaults.fechaHasta,
    };
    setFiltros(parsed);
    setInitialized(true);
  }, []);

  const syncUrl = (newFiltros) => {
    const qs = new URLSearchParams();
    Object.entries(newFiltros).forEach(([k, v]) => {
      if (v == null || v === "" || v === defaults[k]) return;
      if (moment.isMoment(v)) {
        qs.set(k, v.format("YYYY-MM-DD"));
      } else {
        qs.set(k, v);
      }
    });
    window.history.replaceState(null, "", `${window.location.pathname}?${qs}`);
  };

  return { filtros, setFiltros, syncUrl, initialized };
}
